import JSONAPIAdapter from '@ember-data/adapter/json-api';
import { inject as service } from '@ember/service';
import { computed } from '@ember/object';
import { isNone } from '@ember/utils';
import config from 'ui-ember-vite/config/environment';

export default class ApplicationAdapter extends JSONAPIAdapter {
  @service session;

  @computed('config.API.{host,namespace}')
  get host() {
    return config.API.host || undefined;
  }

  @computed('config.API.namespace')
  get namespace() {
    return config.API.namespace;
  }

  @computed('session.{isAuthenticated,data.authenticated.token}')
  get headers() {
    let headers = {
      'Content-Type': 'application/vnd.api+json',
    };

    if (this.session.isAuthenticated) {
      headers['Authorization'] =
        `Bearer ${this.session.data.authenticated.token}`;
    }

    return headers;
  }

  query(store, type, query) {
    if (isNone(query.filter) || isNone(query.filter.page_number)) {
      if (isNone(query.filter)) {
        query.filter = {};
      }

      query.filter.page_enabled = null;
    }

    return super.query(...arguments);
  }
}